import React from "react";
import { Permission } from "Constants";
import { useAllowedTo } from "Hooks";

type AllowedToProps = {
  permissions: Permission[];
  groupId?: string;
  children?: React.ReactNode;
};

const AllowedTo = ({
  permissions,
  groupId,
  children,
}: AllowedToProps): React.JSX.Element | null => {
  const isAllowed = useAllowedTo({ permissions, groupId });
  return isAllowed ? <>{children}</> : null;
};

export default AllowedTo;
